import { render } from "./SearchAutocomplete.vue?vue&type=template&id=1026d94f&scoped=true"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"

import "./SearchAutocomplete.vue?vue&type=style&index=0&id=1026d94f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1026d94f"]])

export default __exports__